var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAg = function SvgIconAg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 12c0 .821.083 1.624.24 2.4l11.76.73 11.76-.73a12.05 12.05 0 0 0 0-4.8L12 8.868l-11.76.73C.083 10.375 0 11.177 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M23.76 14.4H.24C1.352 19.876 6.194 24 12 24c5.805 0 10.648-4.123 11.76-9.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.24 9.6h23.52C22.648 4.123 17.805 0 12 0 6.194 0 1.352 4.123.24 9.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M17.218 9.6H6.783l2.132-1.003L7.78 6.532l2.315.443.293-2.339 1.613 1.72 1.612-1.72.293 2.339 2.315-.443-1.135 2.065z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A2001D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12c0 6.628 5.373 12 12 12L2.4 4.8A11.95 11.95 0 0 0 0 12M12 24c6.627 0 12-5.373 12-12 0-2.702-.893-5.195-2.4-7.2z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconAg;